import { useMutation, useQuery } from '@tanstack/react-query';
import apiClient from './apiClient';

const statisticsKeys = {
  all: ['statistics'],
  coupons: (filters = {}) => [...statisticsKeys.all, 'coupons', filters],
};

const sanitizeStatisticsFilters = (filters = {}) =>
  Object.fromEntries(
    Object.entries(filters).filter(
      ([_, value]) => value !== '' && value !== null && value !== undefined
    )
  );

export const fetchCouponsStatistics = async (filters = {}) => {
  const filteredFilters = sanitizeStatisticsFilters(filters);
  const response = await apiClient.post('statistics/coupons', filteredFilters);
  return response.data;
};

/**
 * Hook para obtener estadísticas de cupones
 */
export const useCouponsStatistics = () => {
  return useMutation({
    mutationFn: fetchCouponsStatistics,
    onError: (error) => {
      console.error('Error getting coupons statistics:', error);
    },
  });
};

/**
 * Hook de consulta cacheable para estadísticas de cupones.
 */
export const useCouponsStatisticsQuery = (filters = {}, options = {}) =>
  useQuery({
    queryKey: statisticsKeys.coupons(sanitizeStatisticsFilters(filters)),
    queryFn: () => fetchCouponsStatistics(filters),
    staleTime: 5 * 60 * 1000,
    gcTime: 10 * 60 * 1000,
    ...options,
  });
